export * from './post-tour.component';
export * from './post-tour.component.module';